import React, {useState} from "react"
import {Controller, useForm} from "react-hook-form";
import {EditCoachSessions} from "../../../services/coaching.service";
import {Col, notification, Row} from "antd";
import {RoundedCheck} from "../../../../assets/icons/defaultIcons";
import {Form} from "react-bootstrap";
import {checkEmptySpaces, maxLength, Required} from "../../../utils/patterns";
import SimpleRichTextEditor from "../../../components/common/rich-text-editor/SimpleRichTextEditor";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import {useNavigate, useParams} from "react-router-dom";

export default function EditSessionNote({open, close, sessionData,handleSession}) {
    let { id } = useParams();
    let navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [renderContent, setRenderContent] = useState(false);
    const [loader,setLoader] = useState(false)
    const {
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
        control,
        clearErrors,
        watch,
    } = useForm({
        mode: "onChange",
    });

    const onSubmit = async (data) => {
        setLoader(true)
        let payload = {
            clientId: sessionData.clientId,
            sessionNote: data?.session_notes,
        };
        try {
            let res = await EditCoachSessions(payload, sessionData._id);
            if (res?.data?.data?.status) {
                notification.success({
                    message: "Success",
                    description: res?.data?.data?.message,
                    placement: "topRight",
                    icon: <RoundedCheck />,
                    duration: 2,
                });
                // Update the coach note in the state
                handleSession()
                close(false)
            }
        } catch (error) {
            console.log("ThisIsErr", error);
            console.log("ThisIsErr2", error?.response);
        } finally {
            // setSessionEdit(null);
            // setRenderContent(!renderContent);
            // reset();
            // setLoader(false)
            // navigate(`/coaching/client-details/${id}`)
        }
    };
    return(
        <div>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="main_div_client_details">
                    <Row gutter={[16, 16]}>
                        <Col xs={24} lg={24} xl={24} md={24}>
                            <div className="col_1_div">
                                <div className="inner_div_col_1">
                                    <div className="form_div">
                                        {/*<h5>Coach Note</h5>*/}
                                        <div className={"dfields"}>
                                            <Controller
                                                name="session_notes"
                                                defaultValue={sessionData.sessionNote ? sessionData.sessionNote : '' }
                                                control={control}
                                                rules={{
                                                    required: Required,
                                                    maxLength: maxLength(10000),
                                                    validate: checkEmptySpaces,
                                                }}
                                                render={({ field }) => (
                                                    <SimpleRichTextEditor
                                                        value={field.value}
                                                        onChange={field.onChange}
                                                        placeholder={"Write your session notes here..."}
                                                        className="required"
                                                        error={errors.session_notes}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className={"dfields mt-3"}>
                                <ThemeButton
                                    text={"Submit"}
                                    className={"btn-light-lg"}
                                    type={"submit"}
                                    loader={loader}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Form>
        </div>
    )
}